export const GLOBAL_STORE = "global_store";
